<template>
  <div style="display: flex; align-items: center">
    <el-input
      v-if="isInput"
      v-model="model"
      :clearable="true"
      :placeholder="placeholder"
      @change="change"
      @blur="blur"
    >
      <template #prefix>
        <IconifyIconOffline :icon="Search" />
      </template>
    </el-input>

    <el-button
      v-if="isSearch"
      v-auth="auth"
      :class="isInput ? 'chss-m-l' : ''"
      type="primary"
      :disabled="disabled"
      :loading="loading"
      @click="onChange(model)"
    >
      <i v-if="isIcon" class="iconfont-chss icon-chss-sousuo" />
      {{ label }}
    </el-button>
  </div>
</template>
<script setup>
import Search from "@iconify-icons/ep/search";
const props = defineProps({
  placeholder: {
    type: String,
    default: "请输入"
  },
  isSearch: {
    type: Boolean,
    default: false
  },
  auth: {
    type: String,
    default: ""
  },
  isInput: {
    type: Boolean,
    default: true
  },
  isIcon: {
    type: Boolean,
    default: true
  },
  label: {
    type: String,
    default: "搜索"
  },
  disabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  width: {
    type: [Number, String],
    default: 340
  },
  isChange: {
    type: Boolean,
    default: true
  }
});
const emit = defineEmits(["change", "blur"]);
const model = defineModel({ default: "" });
function change(value) {
  if (props.isChange) {
    emit("change", value);
  }
}
function onChange(value) {
  emit("change", value);
}
function blur() {
  emit("blur");
}
</script>
<style scoped lang="scss"></style>
